'use strict';

import 'angular';

import formModule from './form';
import fieldModule from './field';
import proxyFieldModule from './proxy-field';
import buttonsModule from './buttons';
import errorsModule from './errors';
import queryModule from './query';

const MODULE_NAME = 'brg.rest';

angular.module(MODULE_NAME, [
	formModule,
	fieldModule,
	proxyFieldModule,
	buttonsModule,
	errorsModule,
	queryModule,
]);

export default MODULE_NAME;
